import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import './DateSelector.scss';
import {ReactComponent as CalendarIcon} from '../../../resources/images/icons/calendar-icon.svg';

interface DateSelectorProps {
  selectedDate: Date | null;
  onDateChange: (date: Date | null) => void;
  placeholder?: string;
  maxToday?: boolean;
}

const DateSelector: React.FC<DateSelectorProps> = ({ selectedDate, onDateChange, placeholder, maxToday }) => {
  const maxDate = maxToday ? new Date() : undefined;
  return (
    <div className={`date-selector ${placeholder === 'To' ? 'to-date-selector':''}`}>
      <DatePicker
        selected={selectedDate}
        onChange={date => onDateChange(date)}
        dateFormat="MMM d, yyyy"
        showYearDropdown
        showMonthDropdown
        showPopperArrow={false}
        maxDate={maxDate}
        customInput={
          <div className="custom-input">
            <input type="text" readOnly placeholder={placeholder || 'select date'} value={selectedDate ? selectedDate.toLocaleDateString() : ''} />
            {/* <img src={CalendarIcon} alt="Calendar" /> */}
            <CalendarIcon style={{width: "20px", margin: "8px"}}/>
          </div>
        }
      />
    </div>
  );
};

export default DateSelector;
